import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import NumericInput from "../numericInput";
import { useAgeFilter } from "../filters/useAgeFilter";

const FilterAge = ({ talentFilter, talentFilterTags, onAddFilter, controlledValues }) => {
  const {
    ageValues,
    setMin,
    setMax,
    isDisabled,
    buildAgeFilter,
  } = useAgeFilter(talentFilter, talentFilterTags, controlledValues);

  const handleAdd = () => {
    const payload = buildAgeFilter();
    if (!payload) return;

    onAddFilter("age", payload);
  };

  return (
    <div className="p-[12px] w-[250px]">
      <div>Select age range</div>

      <div className="grid grid-cols-2 gap-2">
        <div className="border border-[#D9D9D9] rounded py-1 px-2">
          <div className="text-[11px]">MIN</div>
          <NumericInput
            className="border-none p-0"
            value={ageValues.start_value}
            placeholder="Example: 18"
            maxLength={2}
            onChange={setMin}
          />
        </div>

        <div className="border border-[#D9D9D9] rounded py-1 px-2">
          <div className="text-[11px]">MAX</div>
          <NumericInput
            className="border-none p-0"
            value={ageValues.end_value}
            maxLength={3}
            placeholder="Example: 45"
            onChange={setMax}
          />
        </div>
      </div>

      <div className="text-right">
        <Button
          disabled={isDisabled}
          className="mt-[10px]"
          onClick={handleAdd}
          icon={<PlusOutlined />}
        >
          Add Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterAge;
